import { render, staticRenderFns } from "./edit-create-user.vue?vue&type=template&id=0addf0d2"
import script from "./edit-create-user.vue?vue&type=script&lang=ts"
export * from "./edit-create-user.vue?vue&type=script&lang=ts"
import style0 from "./edit-create-user.vue?vue&type=style&index=0&id=0addf0d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports